import React from "react";
function Terms () {
    return (

        <h2>Terms</h2>
    )
    
}
export default Terms;